<template>
    <div>
        <PayAlert :isShow="isShow" @increase="getAlertState"/>
        <ContentHeader :disabled="true" :title="lang('groupLeftMenuText1_2',language)"/>
        <SelectDate @increase="getDateRange"/>
        <Card>
            <p slot="title" :style="{textAlign:'left',fontSize:'18px',fontWeight:'bold'}">
                {{lang('groupStatReadingDetailText1',language)}}
            </p>
            <Button slot="extra" type="primary" @click="exportData">
                <Icon type="ios-download-outline"></Icon>
                {{lang('exportText',language)}}
            </Button>
            <div :style="{position:'relative'}">
                <Spin fix v-if="showLoading"></Spin>
                <Table show-header border :columns="columnsArr" :data="dataArr"></Table>
            </div>
            <br>
            <Page :total="total" show-sizer show-total show-elevator @on-change="changePage"
                  :page-size-opts="[10, 20, 30, 40, 50]" :page-size="pageSize"
                  @on-page-size-change="changePageSize" placement="top" width=""/>
        </Card>

    </div>
</template>

<script>
    var _hmt = _hmt || [];
    (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?4537bce4a2128c98b476fa3bc3b18f86";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();

    import {lang} from "@/utils/language.js";
    import store from '@/store/index.js';
    import config from '@/utils/config.js';
    import ContentHeader from '@/components/ContentHeader.vue';
    import SelectDate from '@/components/SelectDate.vue';
    import {get,getScopeArgs} from '@/utils/net.js';
    import PayAlert from '@/components/PayAlert.vue';

    export default {
        name: "StatReadingDetail",
        store,
        components: {
            ContentHeader,
            SelectDate,
            PayAlert
        },
        data() {
            return {
                isShow:false,
                lang: lang,
                stateLang: '',
                columnsArr: [],
                dataArr: [],
                showLoading: false,
                userId: '',
                scopeType: '',
                scope: '',
                start: '',
                end: '',
                total: 0,
                page: 1,
                pageSize: 10
            }
        },
        mounted() {
            this.getReadingDetailTableTitleArr();
        },
        methods: {
            /*获取表头数据*/
            getReadingDetailTableTitleArr() {
                this.columnsArr.splice(0);
                for (var i = 1; i <= 10; i++) {
                    var item = {};
                    item.title = this.lang('groupStatReadingDetailTableTitleText' + i, this.language);
                    item.key = this.lang('groupStatReadingDetailTableTitleText' + i + '_key', this.language);
                    if(item.key === 'bookNames'){
                        item.width = 400
                    }else{
                        item.width = 200
                    }
                    if(item.key === 'nickname'){
                        item.fixed = 'left'
                    }
                    this.columnsArr.push(item);
                }
            },

            /*获取表格数据*/
            getReadingDetailTableData() {
                let that = this;
                this.dataArr.splice(0);
                that.showLoading = true;
                get({
                    context: that,
                    url: '/open/reading/detail',
                    params: {
                        start: that.start,
                        end: that.end,
                        page: that.page,
                        pageSize: that.pageSize,
                        de: config.de,
                    },
                    onCallBack: function (retMap) {
                        that.total = retMap.total;
                        that.dataArr = retMap.list;
                        that.showLoading = false;
                    },
                    onErr(res) {
                        that.$Message.error(this.lang('systemError', that.language));
                        that.showLoading = false;
                    }
                })
            },
            getDateRange(data) {
                this.start = data.t2;
                this.end = data.t1;
                this.getReadingDetailTableData();
            },
            changePage(page) {
                this.page = page;
                this.getReadingDetailTableData();
            },
            changePageSize(pageSize) {
                this.pageSize = pageSize;
                this.getReadingDetailTableData();
            },

            getAlertState(data){
                this.isShow = data
            },

            exportData(){
                if(this.userInfo.isSvip){
                    let that = this;
                    let path = getScopeArgs({
                        context: that,
                        url: '/open/reading/detail/export',
                        params: {
                            start: that.start,
                            end: that.end,
                            de: config.de,
                        }
                    })
                    let a = document.createElement("a");
                    a.setAttribute("href", path);
                    a.setAttribute("target", "_blank");
                    a.click();
                }else{
                    this.isShow = true;
                }
            }
        },
        computed: {
            language: function () {
                this.stateLang = store.state.lang;
                return store.state.lang;
            },
            userInfo: function () {
                return store.getters.getUser;
            }
        },
        watch: {
            stateLang: function () {
                this.getReadingDetailTableTitleArr();
            }
        },

    }
</script>

<style scoped>

</style>
